__turbopack_context__.v({
  "active": "index-module-scss-module__X-08BW__active",
  "body": "index-module-scss-module__X-08BW__body",
  "bodyHeader": "index-module-scss-module__X-08BW__bodyHeader",
  "button": "index-module-scss-module__X-08BW__button",
  "close": "index-module-scss-module__X-08BW__close",
  "desc": "index-module-scss-module__X-08BW__desc",
  "error": "index-module-scss-module__X-08BW__error",
  "field": "index-module-scss-module__X-08BW__field",
  "header": "index-module-scss-module__X-08BW__header",
  "input": "index-module-scss-module__X-08BW__input",
  "modal": "index-module-scss-module__X-08BW__modal",
  "otherField": "index-module-scss-module__X-08BW__otherField",
  "referralItems": "index-module-scss-module__X-08BW__referralItems",
  "subTitle": "index-module-scss-module__X-08BW__subTitle",
  "title": "index-module-scss-module__X-08BW__title",
});
